import Message from './message';

$(() => {
    if (window.FlashMessage) {
        FlashMessage.$destroy(true);
    }

    window.FlashMessage = new Message({
        el: document.querySelector('#js-msg-container')
    })
});